import { render, staticRenderFns } from "./kalendereinstellungen.vue?vue&type=template&id=2f0a6c71&"
import script from "./kalendereinstellungen.vue?vue&type=script&lang=js&"
export * from "./kalendereinstellungen.vue?vue&type=script&lang=js&"
import style0 from "./kalendereinstellungen.vue?vue&type=style&index=0&id=2f0a6c71&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports